export const getTableRowBackgroundColor = (isSelected: boolean, isHovered: boolean = false): string => {
  if (isSelected && isHovered) {
    return 'bg-info bg-opacity-20';
  }
  if (isSelected) {
    return 'bg-info bg-opacity-10';
  }
  if (isHovered) {
    return 'bg-lvl2';
  }
  return 'bg-lvl1';
};
